import { bl_fi_sales_contract_template_mail_merge_hdr_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class SalesContractTemplateMailMergeHdrContainerModel extends BaseContainerModel {
    bl_fi_sales_contract_template_mail_merge_hdr: bl_fi_sales_contract_template_mail_merge_hdr_RowClass = new bl_fi_sales_contract_template_mail_merge_hdr_RowClass();
}